module.exports = __webpack_public_path__ + "static/media/VK.b96b098e.svg";